import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

interface CookieConsentState {
  essential: boolean;
  marketing: boolean;
}

// Export function to show banner from anywhere
export const showCookieBanner = () => {
  window.dispatchEvent(new CustomEvent("show-cookie-banner"));
};

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("jc-cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }

    // Listen for manual trigger to show banner
    const handleShowBanner = () => setShowBanner(true);
    window.addEventListener("show-cookie-banner", handleShowBanner);
    return () => window.removeEventListener("show-cookie-banner", handleShowBanner);
  }, []);

  const acceptAll = () => {
    const consent: CookieConsentState = { essential: true, marketing: true };
    localStorage.setItem("jc-cookie-consent", JSON.stringify(consent));
    setShowBanner(false);
  };

  const acceptEssential = () => {
    const consent: CookieConsentState = { essential: true, marketing: false };
    localStorage.setItem("jc-cookie-consent", JSON.stringify(consent));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-6 md:max-w-md">
      <div className="bg-card/95 backdrop-blur-xl border border-border/30 rounded-2xl p-4 shadow-2xl">
        <h3 className="font-medium text-foreground text-sm mb-2">Cookie-Einstellungen</h3>
        <p className="text-xs text-muted-foreground mb-3">
          Wir verwenden Cookies für grundlegende Funktionen und zur Analyse unserer Werbemaßnahmen (Meta Pixel). 
          Sie können selbst entscheiden, welche Cookies Sie zulassen möchten.
        </p>
        <p className="text-xs text-muted-foreground/70 mb-4">
          Mehr Infos in unserer <a href="/datenschutz" className="underline hover:text-foreground">Datenschutzerklärung</a>.
        </p>
        <div className="flex gap-2 justify-end">
          <Button
            size="sm"
            variant="outline"
            onClick={acceptEssential}
            className="text-xs font-medium"
          >
            Nur notwendige
          </Button>
          <Button
            size="sm"
            onClick={acceptAll}
            className="text-xs font-medium bg-accent text-accent-foreground hover:bg-accent/90"
          >
            Alle akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
